import { render, staticRenderFns } from "./detailsStorage.vue?vue&type=template&id=3321c552"
import script from "./detailsStorage.vue?vue&type=script&lang=js"
export * from "./detailsStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports